// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { dealerInformationStyles } from "@guestsupply/Overrides/Widgets/DealerDetails/DealerInformation";
import Phone from "@insite/mobius/Icons/Phone";
import { css } from "styled-components";

dealerInformationStyles.container = {
    gap: 0,
    css: css`
        margin-bottom: 20px;
    `,
};

dealerInformationStyles.nameGridItem = {
    width: 12,
};
dealerInformationStyles.nameText = {
    size: 20,
    weight: 400,
    as: "p",
    css: css`
        margin-bottom: 5px;
    `,
};
dealerInformationStyles.addressInfoGridItem = {
    width: 12,
    css: css`
        padding: 5px 0;
    `,
};

dealerInformationStyles.phoneGridItem = {
    width: 12,
    css: css`
        padding-bottom: 5px;
    `,
};
dealerInformationStyles.phoneLink = {
    color: "text",
};
dealerInformationStyles.htmlContentGridItem = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
        &&& {
            margin-bottom: 8px;
        }
    `,
};
dealerInformationStyles.googleMapsDirectionLinkGridItem = {
    width: 12,
    css: css`
        gap: 5px;
        margin: 8px 0 50px 0;
    `,
};
dealerInformationStyles.visitWebsiteLinkGridItem = {
    width: 12,
};
dealerInformationStyles.htmlContainer = {
    gap: 10,
};
dealerInformationStyles.googleMapsDirectionLink = {
    mergeCss: true,
    typographyProps: {
        size: 16,
        weight: 400,
    },
};
dealerInformationStyles.visitWebsiteLink = {
    mergeCss: true,
    typographyProps: {
        size: 16,
        weight: 400,
    },
};

dealerInformationStyles.addressInfoIcon = {
    src: "MapPin",
    color: "primary",
    size: 16,
    css: css`
        margin-top: 4px;
    `,
};

dealerInformationStyles.phoneLink = {
    icon: {
        iconProps: {
            src: Phone,
            color: "primary",
            size: 16,
            css: css`
                margin: 0;
            `,
        },
        position: "left",
    },
    typographyProps: {
        css: css`
            padding-left: 5px;
        `,
    },
};

dealerInformationStyles.addressInfoCondensed = {
    wrapper: {
        css: css`
            padding-left: 5px;
            font-style: normal;
        `,
    },
};
